import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')
const Display = () => import('./views/Display')
const Create = () => import('./views/Create')
const PromoCodeList = () => import('./views/PromoCodeList')
const PromoCodeDisplay = () => import('./views/PromoCodeDisplay')
const PromoCodeCreate = () => import('./views/PromoCodeCreate')

const ROUTE_NAME = 'profile:marketing-campaign:'

const p = name => ROUTE_NAME + name

const LIST = p('list')
const CREATE = p('create')
const DISPLAY = p('display')
const PROMO_CODE_LIST = 'profile:promo-code:list'
const PROMO_CODE_CREATE = 'profile:promo-code:create'
const PROMO_CODE_DISPLAY = 'profile:promo-code:display'

export function createRoutes(options) {
  return [
    route('list/', List, LIST, {
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR], options),
      },
    }),
    route('create/', Create, CREATE, {
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR], options),
      },
    }),
    route('promo-code/list/', PromoCodeList, PROMO_CODE_LIST, {
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER_WAREHOUSE, TYPES.STOCK_INFO], options),
      },
    }),
    route('promo-code/create/', PromoCodeCreate, PROMO_CODE_CREATE, {
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER_WAREHOUSE, TYPES.STOCK_INFO], options),
      },
    }),
    route('promo-code/:id/', PromoCodeDisplay, PROMO_CODE_DISPLAY, {
      props: true,
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER_WAREHOUSE, TYPES.STOCK_INFO], options),
      },
    }),
    route(':id/', Display, DISPLAY, {
      props: true,
      meta: {
        accessConfig: accessPermission([TYPES.ADMINISTRATOR, TYPES.MANAGER_WAREHOUSE, TYPES.WEBSITE_MODERATOR], options),
      },
    }),
  ]
}
